<template>
    <div class="tableToolbarBlock">
        <q-item class="toolbar">
            <slot>
                <!-- fallback content -->
            </slot>
        </q-item>
    </div>
</template>

<script>
export default {
    name: 'CTableToolbar',
    setup() {
        return {};
    },
};
</script>

<style lang="scss" scoped>
.tableToolbarBlock {
    height: 24px;
    margin-bottom: 8px;
    @media (max-width: $breakpoint-sm-max) {
        display: none;
    }
}
.q-item {
    // flex-wrap: wrap;
    background: transparent;
    font-size: em(16);
    min-height: 24px;
    padding: 0;
    margin: 0 24px 0 24px;

    :deep() .q-item__section {
        min-height: 24px;
        padding: 0 16px;
        color: $dark;
        // margin-left: 16px;
        // margin-right: 16px;
        align-content: start;

        &.col1 {
            min-width: 200px !important;
        }

        &.content-center {
            align-content: center;
        }

        &.content-end {
            align-content: end;
        }

        // &:first-child {
        //     margin-left: 24px;
        // }
        // &:last-child {
        //     margin-right: 24px;
        // }

        &.q-item__section--avatar {
            min-width: auto;
        }
    }
}
</style>
